export default "__VITE_ASSET__C1GSbJ1Q__"